(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('wikiPageTree', wikiPageTree);

    function wikiPageTree() {
        return {
            restrict: 'E',
            templateUrl: 'app/entities/wiki/wiki-page-tree.html',
            controller: 'WikiPageTreeController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                pages: '=',
                spaceId: '=',
                currentPageId: '=',
                onTreeChange: '&'
            }
        };
    }
})();
